import { render, staticRenderFns } from "./BulkTransferP2PMemberCode.vue?vue&type=template&id=12969c82"
import script from "./BulkTransferP2PMemberCode.vue?vue&type=script&lang=js"
export * from "./BulkTransferP2PMemberCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports